import { useSearchParams } from 'src/hooks/useSearchParams';
import { useEffect } from 'react';
import { appendNativeParam } from 'src/utils/url.utils';

/** Hook to append native param to search params, if the user is using Spendsmart on the mobile app */
export const useAppendNativeParam = (): void => {
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        appendNativeParam(searchParams, setSearchParams);
    }, [searchParams, setSearchParams]);
};
